module.exports = __webpack_public_path__ + "img/rascrut-1.d3de3d6c.webp";